import type { ActualUnit, ActualUnitsListResponse, PatchActualUnit } from "@classes-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import type { UndefinedToNull } from "@/components/Account/types";
import { learningServiceRequest } from "@/services/utils";

export const getQueryKey = () => ["patchUnits"];

type PartialUpdateUnitNamesArgs = {
  payload: UndefinedToNull<PatchActualUnit>;
};

export const usePatchActualUnitNames = (
  useMutationOptions?: UseMutationOptions<ActualUnit[], Error, PartialUpdateUnitNamesArgs>,
) => {
  return useMutation<ActualUnit[], Error, PartialUpdateUnitNamesArgs>({
    mutationFn: async ({ payload }) => {
      const response: AxiosResponse<ActualUnitsListResponse> = await learningServiceRequest({
        method: "patch",
        url: `/housings/actual_units/names`,
        payload: payload,
      });
      return response.data.items;
    },
    ...useMutationOptions,
  });
};
